export default __webpack_public_path__ + "static/media/YAS0160.34I-27752_-16661_0.78b72284.jpg";